import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { appFeature } from '@app/core/store/app.reducer';
import { RoleFunctionName } from '@app/core/enums/role-function-name.enum';
import { AccessMatrixLevel } from '@app/core/enums/access-settings.enums';

const LEVEL_ORDER: Record<AccessMatrixLevel, number> = {
  [AccessMatrixLevel.NoAccess]: 0,
  [AccessMatrixLevel.Review]: 1,
  [AccessMatrixLevel.Edit]: 2
};

export const functionGuard = (
  fns: RoleFunctionName[],
  minLevel: AccessMatrixLevel = AccessMatrixLevel.Review
): CanActivateFn => {
  return () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(appFeature.selectUser).pipe(
      filter(Boolean),
      map(user => {
        const fnMap = user.functionNames ?? {};
        const hasAccess = fns.some(fn => {
          const level = fnMap[fn];
          return (
            level !== undefined &&
            LEVEL_ORDER[level] >= LEVEL_ORDER[minLevel]
          );
        });

        if (hasAccess) {
          return true;
        } else {
          router.navigate(['/not-access']);
          return false;
        }
      })
    );
  };
};
